module.exports = __webpack_public_path__ + "static/media/desktop2.ff348d8e.png";